import AntdModal3 from 'components/AntdModal3';
import { Form } from 'antd';
import { useForm } from 'antd/es/form/Form';
import FormLabelGrid from 'page/Application/ManageNotificationList/NotificationList/component/FormLabelGrid';
import ButtonModalSearch from 'page/Application/ManageNotificationList/component/ButtonModalSearch';
import React, { useEffect, useMemo, useState } from 'react';
import useMultiLanguageNotificationList from 'page/Application/ManageNotificationList/NotificationList/hook/useMultiLanguageNotificationList';
import { FormTextRequired } from 'page/Application/ManageCompanyList/component/Form';
import { FormWrapper } from 'components/Form/Template/styled';
import {
  Grid1,
  Grid2,
  GridForm,
} from 'page/Application/ManageCompanyList/CompanyList/styled';
import { FormDropDown } from 'page/Application/ManageProductAndService/Content/component';
import FormSelectSearch from 'page/Application/ManageCompanyList/CompanyList/component/FormSelectSearch';
import { getListProduct } from 'api/partner/partner.api';
import useSearchKeyword from 'hook/useSearchKeyword';
import useCustomQuery from 'hook/useQuery/useCustomQuery';

const ModalFilter = ({
  modalKey,
  isModalOpen,
  setIsModalOpen,
  filterDataState,
  setFilterData,
  setResetStatusFilter,
  resetStatusFilter,
  setSortedInfo,
  width,
  setIsFilter,
  errorNetWork,
  isOnline,
  setSearchKeywordList,
  setSearchValueList,
  setEmptyTextList,
  setProductIdExist,
}) => {
  const [form] = useForm();
  const { useQueryAPI } = useCustomQuery();
  const values = Form.useWatch([], form);
  const [submittable, setSubmittable] = useState(false);
  const [idProduct, setIdProduct] = useState('');
  const { NOTIFICATION_LIST_MODAL_BUTTON_RESET } =
    useMultiLanguageNotificationList();
  const { searchKeyword, onSearch, setSearchKeyword } = useSearchKeyword();

  const isAutoApprove = [
    { key: 0, label: '許可', value: 'true' },
    { key: 1, label: '不可', value: 'false' },
  ];
  const partnerType = [
    { key: 0, label: '一次店', value: 'DIRECT_SALES' },
    { key: 1, label: '二次店(SBP)', value: 'SECONDARY_DISTRIBUTOR' },
    { key: 2, label: '構築/保守/運用会社', value: 'SERVICE_PROVIDER' },
    { key: 3, label: 'その他', value: 'OTHER' },
  ];

  const { data: dataProductList, isLoading } = useQueryAPI({
    api: getListProduct,
    params: {
      keyword: searchKeyword,
      isNotify: false,
    },
    key: 'productList',
  });

  const productList = useMemo(() => {
    if (
      dataProductList &&
      dataProductList?.data &&
      dataProductList?.ec === false
    ) {
      return dataProductList?.data?.listProduct?.map((item) => ({
        ...item,
        key: item.id,
        label: item.productName,
        value: item.id,
      }));
    } else return [];
  }, [dataProductList]);

  const handleOk = (values) => {
    if (isOnline) {
      const payload = {
        ...values,
        domainName: values?.domainName?.trim(),
        partnerName: values?.partnerName?.trim(),
        solitonEmail: values?.solitonEmail?.trim(),
      };
      const hasFilter = (obj) => {
        return Object.values(obj).some(
          (value) => value !== null && value !== undefined && value !== '',
        );
      };
      if (hasFilter(payload)) {
        setEmptyTextList('データが見つかりませんでした。');
      }
      setIsFilter(hasFilter(payload));
      setSortedInfo({});
      setIsModalOpen(false);
      setFilterData(payload);
      setResetStatusFilter(false);
      setSearchKeywordList('');
      setSearchValueList('');
    } else {
      errorNetWork();
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onReset = () => {
    form.resetFields();
    setIdProduct('');
  };

  const handleSetApprove = (value) => {
    form.setFieldValue('isAutoApprove', value);
  };

  const handleSetProductId = (value) => {
    setIdProduct(value);
    form.setFieldValue('productId', value);
  };

  const handleSetPartnerType = (value) => {
    form.setFieldValue('partnerType', value);
  };

  useEffect(() => {
    const checkExist = productList?.some((item) => item.value === idProduct);

    !!idProduct && setProductIdExist(checkExist);
    form.setFieldValue('productId', checkExist ? idProduct : null);
  }, [idProduct, productList]);

  useEffect(() => {
    if (isModalOpen) {
      form.validateFields().then((values) => {
        if (
          values.domainName ||
          values.isAutoApprove ||
          values.partnerName ||
          values.partnerType ||
          values.productId ||
          values.solitonEmail
        ) {
          setSubmittable(true);
        } else {
          setSubmittable(false);
        }
      });
    }
  }, [values, form, isModalOpen]);

  useEffect(() => {
    if (resetStatusFilter) {
      form.resetFields();
      setIdProduct('');
    }
  }, [resetStatusFilter, form]);

  useEffect(() => {
    if (isModalOpen === false) {
      setSearchKeyword('');
    }
  }, [isModalOpen, setSearchKeyword]);

  useEffect(() => {
    const isFilterDataEmpty = (filterData) => {
      if (filterData && typeof filterData === 'object') {
        return Object?.values(filterData)?.every(
          (value) => value === '' || value === undefined || value === null,
        );
      }
      return true;
    };
    const checkFilterEmpty = isFilterDataEmpty(filterDataState);
    if (!checkFilterEmpty) {
      form.setFieldValue('partnerName', filterDataState?.partnerName);
      form.setFieldValue('domainName', filterDataState?.domainName);
      form.setFieldValue('isAutoApprove', filterDataState?.isAutoApprove);
      form.setFieldValue('partnerType', filterDataState?.partnerType);
      form.setFieldValue('productId', filterDataState?.productId);
      form.setFieldValue('solitonEmail', filterDataState?.solitonEmail);
    } else {
      form.resetFields();
    }
  }, []);

  return (
    <AntdModal3
      title={'絞り込み検索'}
      isModalOpen={isModalOpen}
      handleOk={() => {
        handleOk(values);
      }}
      onCancel={handleCancel}
      width={width}
      footer={[
        <ButtonModalSearch
          modalKey={modalKey}
          cancelText={NOTIFICATION_LIST_MODAL_BUTTON_RESET}
          handleReset={onReset}
          handleOk={() => {
            handleOk(values);
          }}
          submittable={!submittable}
          size={'large'}
        />,
      ]}
    >
      <FormWrapper style={{ marginTop: '20px' }}>
        <Form form={form} layout="horizontal" size="large" autoComplete={'off'}>
          <GridForm style={{ paddingTop: '20px' }}>
            {/*会社名*/}
            <Grid1>
              <FormLabelGrid labelText={'会社名'} />
            </Grid1>
            <Grid2>
              <FormTextRequired formName={'partnerName'} />
            </Grid2>

            {/*アカウント登録ドメイン*/}
            <Grid1>
              <FormLabelGrid labelText={'アカウント登録ドメイン'} />
            </Grid1>
            <Grid2>
              <FormTextRequired formName={'domainName'} />
            </Grid2>

            {/*自動承認*/}
            <Grid1>
              <FormLabelGrid labelText={'自動承認'} />
            </Grid1>
            <Grid2>
              <FormDropDown
                name={'isAutoApprove'}
                data={isAutoApprove}
                onChange={(value) => handleSetApprove(value)}
              />
            </Grid2>

            {/*権限*/}
            <Grid1>
              <FormLabelGrid labelText={'権限'} />
            </Grid1>
            <Grid2>
              <FormSelectSearch
                onSearch={onSearch}
                name={'productId'}
                data={productList}
                isLoading={isLoading}
                onChange={(value) => handleSetProductId(value)}
              />
            </Grid2>

            {/*パートナー種別*/}
            <Grid1>
              <FormLabelGrid labelText={'パートナー種別'} />
            </Grid1>
            <Grid2>
              <FormDropDown
                name={'partnerType'}
                data={partnerType}
                onChange={(value) => handleSetPartnerType(value)}
              />
            </Grid2>

            {/*ソリトン担当お問い合わせ先*/}
            <Grid1>
              <FormLabelGrid labelText={'ソリトン担当お問い合わせ先'} />
            </Grid1>
            <Grid2>
              <FormTextRequired formName={'solitonEmail'} />
            </Grid2>
          </GridForm>
        </Form>
      </FormWrapper>
    </AntdModal3>
  );
};

export default ModalFilter;
